<template>
  <div class="pgs-report-container pb-n16">
    <ModuleHeader>Reporte General </ModuleHeader>
    <v-overlay v-if="loadingData" z-index="100">
      <v-progress-circular indeterminate size="64" color="primary"></v-progress-circular>
    </v-overlay>

    <v-row>
      <v-col md="12" cols="12">
        <v-card rounded="xl" elevation="2" class="mb-4 filter-card">
          <v-card-text>
            <v-row align="center">
              <v-col md="2" cols="12">
                <v-menu v-model="menuFechaInicial" :close-on-content-click="false" :nudge-right="40"
                  transition="scale-transition" offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="input_date" label="Fecha Inicial" prepend-inner-icon="mdi-calendar" readonly
                      outlined dense hide-details v-bind="attrs" v-on="on" class="rounded-lg"></v-text-field>
                  </template>
                  <v-date-picker v-model="input_date" @input="menuFechaInicial = false"></v-date-picker>
                </v-menu>
              </v-col>
              <v-col md="2" cols="12">
                <v-menu v-model="menuFechaInicial2" :close-on-content-click="false" :nudge-right="40"
                  transition="scale-transition" offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="input_date_final" label="Fecha Final" prepend-inner-icon="mdi-calendar"
                      readonly outlined dense hide-details v-bind="attrs" v-on="on" class="rounded-lg"></v-text-field>
                  </template>
                  <v-date-picker v-model="input_date_final" @input="menuFechaInicial2 = false"></v-date-picker>
                </v-menu>
              </v-col>
              <v-col md="2" cols="12">
                <v-autocomplete label="Departamentos" v-model="selectDep" item-text="Nombre" item-value="id"
                  :items="departamentos" outlined dense hide-details class="rounded-lg"></v-autocomplete>
              </v-col>
              <v-col md="2" cols="12">
                <v-autocomplete label="Cliente" item-value="value" v-model="selectClient" :items="comp_clients" outlined
                  dense hide-details class="rounded-lg"></v-autocomplete>
              </v-col>
              <v-col md="2" cols="12">
                <v-text-field v-model="input_folio" label="Folio de Venta" outlined dense hide-details
                  class="rounded-lg"></v-text-field>
              </v-col>
              <v-col md="2" cols="12" class="d-flex align-center">
                <v-btn depressed block height="40"
                  @click="datos = { processedData: [], all: [], totales: { Cantidad: 0, Descuento: 0, Monto: 0, Subtotal: 0, Impuestos: 0 } }; currentPage = 1; render = !render"
                  :color="render ? 'grey lighten-2' : 'info'" class="rounded-lg text-none">
                  <v-icon left size="18">{{ render ? 'mdi-eye-off' : 'mdi-eye' }}</v-icon>
                  {{ (render) ? "Solo excel" : "Resultados" }}
                </v-btn>
              </v-col>

              <v-col class="text-right d-flex justify-end gap-2" md="12">
                <v-btn depressed @click="cleanFilter()" color="error" class="rounded-lg text-none px-6" outlined>
                  <v-icon left>mdi-filter-off</v-icon>
                  Restablecer
                </v-btn>
                <v-btn depressed @click="searchVentas()" color="primary" class="rounded-lg text-none px-10 shadow-sm">
                  <v-icon left>mdi-magnify</v-icon>
                  Buscar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col md="12" cols="12">
        <v-card elevation="0">
          <v-card-text>
            <v-row>
              <v-col md="8">
                Resultados: <span v-if="datos.processedData.length > 0"><b>{{ datos.processedData.length }}</b>
                  registros</span>
                <p v-if="!render && datos.processedData.length != 0">
                  <b> Descargue la hoja de excel para ver los resultados</b>
                </p>
                <p v-if="!render && datos.processedData.length == 0">
                  <b> Busqueda sin resultados</b>
                </p>
              </v-col>
              <v-col md="2" class="text-right">
                <v-btn color="green" dark @click="exportExcel"><v-icon>mdi-file-excel-box</v-icon>
                  Exportar a Excel
                  <!-- <download-excel
                    type="xls"
                    name="Reporte General"
                    :data="datos.processedData"
                  >
                  </download-excel> -->
                </v-btn>
              </v-col>
            </v-row>
            <div v-if="render" class="sticky-table-wrapper">
              <v-simple-table class="pgs-modern-table" height="63vh" fixed-header dense>
                <thead>
                  <tr>
                    <th>Fecha</th>
                    <th>Hora</th>
                    <th>Cajero</th>
                    <th>Cliente</th>
                    <th>Personas</th>
                    <th>Membresia</th>
                    <th>Folio</th>
                    <th>Departamento</th>
                    <th>Extra Info</th>
                    <th>Clave SAT</th>
                    <th>Familia</th>
                    <th>Categoría</th>
                    <th>Descripción</th>
                    <th>Cantidad</th>
                    <th>Total</th>
                    <th>Moneda</th>
                    <th>Método de pago</th>
                    <th>Descuento</th>
                    <th>Autorización</th>
                    <th>Subtotal</th>
                    <th>Impuestos</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="datos.processedData.length == 0">
                    <td colspan="20" class="text-center pa-10 grey--text">No se encontraron datos que coincidan con los
                      filtros</td>
                  </tr>
                  <template v-for="(prod, index) in paginatedData">
                    <tr :key="index">
                      <td class="font-weight-medium">{{ prod.Fecha }}</td>
                      <td class="font-weight-medium">{{ prod.Hora }}</td>
                      <td>{{ prod.Cajero }}</td>
                      <td>
                        <div class="d-flex flex-column">
                          <span>{{ prod.Cliente }}</span>
                          <small class="grey--text">{{ prod.Apodo }}</small>
                        </div>
                      </td>
                      <td class="text-center">{{ prod.Personas }}</td>
                      <td><v-chip x-small outlined label>{{ prod.Membresia }}</v-chip></td>
                      <td class="font-weight-bold grey--text text--darken-2">{{ prod.Folio }}</td>
                      <td>{{ prod.Departamento }}</td>
                      <td style="min-width: 155px;">
                        <div class="d-flex align-center">
                          <!-- Ficha de Mesa -->
                          <div class="mesa-badge mr-2 text-center"
                            v-if="prod.Mesa && prod.Mesa !== 'NA' && prod.Mesa !== 'N/A'">
                            <span class="mesa-badge-num">{{ prod.Mesa }}</span>
                            <span class="mesa-badge-lbl">MESA</span>
                          </div>

                          <!-- Detalle: Área + Mesero + Tarifa -->
                          <div class="d-flex flex-column" style="line-height: 1.25;">
                            <span v-if="prod.Area && prod.Area !== 'N/A'"
                              class="font-weight-medium text-caption grey--text text--darken-2 text-no-wrap">
                              {{ prod.Area }}
                            </span>
                            <span v-if="prod.Mesero && prod.Mesero !== 'N/A'"
                              class="primary--text font-weight-medium text-no-wrap" style="font-size: 0.75rem;">
                              {{ prod.Mesero }}
                              <span v-if="prod.SegmentoTarifario" class="grey--text font-weight-regular">· {{
                                prod.SegmentoTarifario }}</span>
                              <span v-if="prod.MercadoTarifario" class="grey--text font-weight-regular">· {{
                                prod.MercadoTarifario }}</span>
                            </span>
                            <span v-else-if="prod.SegmentoTarifario" class="grey--text text-caption"
                              style="font-size: 0.75rem;">
                              {{ prod.SegmentoTarifario }}
                              <span v-if="prod.MercadoTarifario" class="grey--text font-weight-regular">· {{
                                prod.MercadoTarifario }}</span>
                            </span>
                          </div>
                        </div>

                      </td>
                      <td><small>{{ prod.ClaveSAT }}</small></td>
                      <td>{{ prod.Familia }}</td>
                      <td>{{ prod.Categoria }}</td>
                      <td class="text-truncate" style="max-width: 200px" :title="prod.Producto">{{ prod.Producto }}</td>
                      <td class="text-center font-weight-bold">{{ prod.Cantidad }}</td>
                      <td class="text-right font-weight-bold">{{ $pgsHelper.formatNumber(prod.Monto) }}</td>
                      <td><small>{{ prod.Moneda }}</small></td>
                      <td>{{ prod.TipoPago }}</td>
                      <td class="text-right error--text">{{ $pgsHelper.formatNumber(prod.Descuento) }}</td>
                      <td><small>{{ prod.Autorizacion }}</small></td>
                      <td class="text-right">{{ $pgsHelper.formatNumber(prod.Subtotal) }}</td>
                      <td class="text-right">{{ $pgsHelper.formatNumber(prod.Impuestos) }}</td>
                    </tr>
                  </template>
                  <tr v-if="hasMoreData">
                    <td colspan="20" class="text-center pa-4 bg-light">
                      <v-btn color="primary" outlined rounded @click="currentPage++" class="text-none">
                        <v-icon left>mdi-chevron-down</v-icon>
                        Cargar más resultados ({{ paginatedData.length }} de {{ datos.processedData.length }})
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </div>






          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <!-- Sticky Summary Footer -->
    <v-sheet v-if="render && datos.processedData.length > 0"
      class="report-footer-summary px-8 py-4 d-flex justify-end align-center">
      <v-btn color="primary" outlined rounded @click="currentPage++" class="text-none">
        <v-icon left>mdi-chevron-down</v-icon>
        Cargar más resultados ({{ paginatedData.length }} de {{ datos.processedData.length }})
      </v-btn>
      <div class="summary-item px-6">
        <div class="summary-label">Cantidad</div>
        <div class="summary-value">{{ $pgsHelper.formatNumber(datos.totales.Cantidad) }}</div>
      </div>
      <v-divider vertical class="mx-2"></v-divider>
      <div class="summary-item px-6">
        <div class="summary-label">Subtotal</div>
        <div class="summary-value">{{ $pgsHelper.formatNumber(datos.totales.Subtotal) }}</div>
      </div>
      <v-divider vertical class="mx-2"></v-divider>
      <div class="summary-item px-6">
        <div class="summary-label">Descuento</div>
        <div class="summary-value error--text">{{ $pgsHelper.formatNumber(datos.totales.Descuento) }}</div>
      </div>
      <v-divider vertical class="mx-2"></v-divider>
      <div class="summary-item px-6">
        <div class="summary-label">Impuestos</div>
        <div class="summary-value">{{ $pgsHelper.formatNumber(datos.totales.Impuestos) }}</div>
      </div>
      <v-divider vertical class="mx-2"></v-divider>
      <div class="summary-item px-6 highlight">
        <div class="summary-label primary--text">Total General</div>
        <div class="summary-value primary--text text-h5 font-weight-black">
          {{ $pgsHelper.formatNumber(datos.totales.Monto) }}
        </div>
      </div>
    </v-sheet>
  </div>
</template>

<style scoped>
.pgs-report-container {

  background-color: #f8fafc;
  min-height: 100vh;
}

.filter-card {
  border: 1px solid rgba(0, 0, 0, 0.05) !important;
}

.gap-2 {
  gap: 12px;
}

.sticky-table-wrapper {
  max-height: 65vh;
  overflow: auto;
  border-top: 1px solid #eee;
}

/* Scrollbar styling */
.sticky-table-wrapper::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.sticky-table-wrapper::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.sticky-table-wrapper::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}

.sticky-table-wrapper::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

.pgs-modern-table {
  background: white !important;
}

.pgs-modern-table thead th {
  position: sticky !important;
  top: 0 !important;
  z-index: 6 !important;
  background: #f8fafc !important;
  font-weight: 700 !important;
  text-transform: uppercase;
  font-size: 0.7rem !important;
  color: #64748b !important;
  border-bottom: 2px solid #e2e8f0 !important;
  white-space: nowrap;
  height: 48px !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);
}

.pgs-modern-table tbody tr:hover {
  background-color: #f1f5f9 !important;
}

.pgs-modern-table tbody td {
  font-size: 0.85rem !important;
  color: #334155 !important;
  border-bottom: 1px solid #f1f5f9 !important;
  height: 56px !important;
}

.mesa-badge {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 2px 7px;
  min-width: 44px;
}

.mesa-badge-num {
  display: block;
  font-weight: 700;
  font-size: 0.8rem;
  color: #1e293b;
  line-height: 1.1;
  white-space: nowrap;
}

.mesa-badge-lbl {
  display: block;
  font-size: 0.55rem;
  font-weight: 600;
  letter-spacing: 0.5px;
  color: #64748b;
}

.report-footer-summary {
  position: sticky;
  bottom: 0;
  z-index: 6;
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-top: 2px solid #e2e8f0 !important;
  box-shadow: 0 -10px 15px -3px rgba(0, 0, 0, 0.05);
}

.summary-item {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.summary-label {
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  font-weight: 700;
  color: #64748b;
  margin-bottom: 2px;
}

.summary-value {
  font-size: 1rem;
  font-weight: 800;
  color: #1e293b;
}

.summary-item.highlight .summary-value {
  font-size: 1.25rem;
}

.bg-light {
  background-color: #f8fafc;
}

.shadow-sm {
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06) !important;
}
</style>

<script>
import "../../assets/css/sideBar.css";
import Cliente from "../../clases/Cliente.js";
import moment from "moment";
import Currency from "../../clases/Currencies.js";
import Membresia from "../../clases/Membresias/Membresia.js";
import Vue from "vue";
import GenericExcelExporter from "../../clases/ExcelMaker/GeneralExcel.js";
import { mapActions } from "vuex";

export default {
  name: "ReporteGeneral",
  components: {
    /*Select2,*/
  },
  props: ["hideMenu"],
  data() {
    return {
      meseros: [],
      contenedores: [],
      areas: [],
      selectDep: "ALL",
      currencyClass: Currency,
      menuFechaInicial: false,
      menuFechaInicial2: false,
      loadingData: false,
      render: true,
      datos: {
        all: [],
        processedData: [],
        totales: { Cantidad: 0, Descuento: 0, Monto: 0, Subtotal: 0, Impuestos: 0 },
      },
      currentPage: 1,
      pageSize: 100,
      input_date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      input_date_final: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      selectedRes: "",
      data_clientes: [],
      input_caja: "",
      selectClient: "",
      input_cajero: "",
      input_folio: "",
      showModal: false,
      formKey: 0,
      data_ventas: [],
      selectedHotel: "",
      hoteles: [],
      Horario: "",
      Horarios: [],
      data_cajas: [],
      reservations: [],
      cashiers: [],
      Categories: [],
      familias: [],

      header: [
        "Cliente",
        "Membresia",
        "Folio",
        "Familia",
        "Categoría",
        "Descripción",
        "Cantidad",
        "Total",
        "Método de pago",
        "Autorización",
        "Total",
        "Impuestos",
      ],
      processedData: [],
    };
  },
  computed: {
    Membresias() {
      return this.$pgsHelper.indexBy(Membresia.getMembresiasList(), "Id");
    },
    selectedReserva() {
      return this.selectedRes;
    },
    comp_clients() {
      let clientes = [];
      let rowclientes = this.$pgsHelper.indexBy(Cliente.getClientsList(), "Id");
      rowclientes.forEach((cli) => {
        clientes.push({ value: cli.Id, text: cli.getNombreCompleto(), ...cli });
      });
      return clientes;
    },
    paginatedData() {
      const end = this.currentPage * this.pageSize;
      return this.datos.processedData.slice(0, end);
    },
    hasMoreData() {
      return this.currentPage * this.pageSize < this.datos.processedData.length;
    },
    departamentos() {
      let dep = [
        {
          id: "ALL",
          Nombre: "Todos",
        },
      ];
      let departamentos = this.$store.getters.getPDVDepartamentos;
      departamentos.forEach((de) => {
        dep.push(de);
      });
      return dep;
    },
  },
  methods: {
    exportExcel() {
      GenericExcelExporter.generateExcelBuffer(this.datos.processedData)
        .then(buffer => {
          const blob = new Blob([buffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = "Reporte General.xlsx";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch(error => console.error("Error exportando:", error));
    },
    processVentas() {
      console.time("ProcessVentas");
      let productosVenta = [];
      let totales = { Cantidad: 0, Descuento: 0, Monto: 0, Subtotal: 0, Impuestos: 0 };

      // ---- PRE-INDEX: construir Maps O(1) en lugar de búsquedas lineales ----
      const clientsMap = new Map();
      this.comp_clients.forEach(c => clientsMap.set(c.Id, c));

      const membresiasMap = new Map();
      this.Membresias.forEach(m => membresiasMap.set(m.Id, m));

      const contenedoresMap = new Map();
      this.contenedores.forEach(c => contenedoresMap.set(c.id, c));

      const areasMap = new Map();
      this.areas.forEach(a => areasMap.set(a.id, a));

      const meserosMap = new Map();
      this.meseros.forEach(m => meserosMap.set(m.id, m));

      const cashiersMap = new Map();
      this.cashiers.forEach(c => cashiersMap.set(c.Id, c));

      const categoriesMap = new Map();
      this.Categories.forEach(c => categoriesMap.set(c.id, c));

      const familiasMap = new Map();
      this.familias.forEach(f => familiasMap.set(f.id, f));
      // ---- FIN PRE-INDEX ----

      this.datos.all.forEach((el) => {
        let client = clientsMap.get(el.Cliente.Id) || false;
        let idMembresia = client ? client.ExtraData?.Membresia?.Membresia : undefined;
        let membresiaData = idMembresia ? (membresiasMap.get(idMembresia) || false) : false;
        let cajeroData = cashiersMap.get(el.Cajero) || {};

        el.Catalogo.forEach((prod) => {
          console.log(prod)
          let familia = prod.Familia ? prod.Familia.N : "-";
          if (prod.Familia.N == "N/A") {
            if (prod.Id.includes("RVA-ExtraRidder")) {
              familia = "EXTRA RIDER";
              prod.Categoria.N = "EXTRA RIDER";
            }
            if (prod.Id.includes("Reserva")) {
              if (prod.Orn != "Golf") {
                familia = prod.Orn;
              } else {
                familia = "GREEN FEE";
              }


            }
            if (prod.Tip == "ACT-Reserva") {
              let categoria = categoriesMap.get(prod.Categoria.I);
              if (categoria) {
                let familiaItem = familiasMap.get(categoria.Familia);
                if (familiaItem) {
                  familia = familiaItem.Nombre;
                }
              }
            }
            if (prod.Id.includes("RVA-Transportacion")) {
              familia = "TRANSPORTACION";
              prod.Categoria.N = "TRANSPORTACION";
            }
            if (prod.Tip == "Cupon") {
              familia = "Paquetes Rondas de Golf";
              prod.Categoria.N = "Paquetes Rondas de Golf";
            }
            if (prod.Tip == "MBS-Beneficio") {
              familia = "Beneficio membresia";
              prod.Categoria.N = "Beneficio memebresia";
            }

            if (prod.Catalogo) {
              if (prod.Catalogo[0]) {
                let Catalogo = prod.Catalogo[0];
                if (Catalogo.Tip == "Serie") {
                  familia = "GREEN FEE";
                  prod.Categoria.N = "Ronda prepagada";
                }
              }
            }
          }
          let segmentoTarifario = "";
          let mercadoTarifario = "";
          if (prod.Tip == "RVA-Reserva") {
            segmentoTarifario = prod.Catalogo?.[0]?.ExtraParams?.TarifaData?.SegN || "N/A";
            mercadoTarifario = prod.Catalogo?.[0]?.ExtraParams?.TarifaData?.MerN || "N/A";
          }
          if (prod.Tip == "RVA-Addon") {
            familia = "AddOn";
            prod.Categoria.N = "AddOn";
          }
          let aybContenedor = "NA";
          let aybArea = "N/A";
          let NombreMesero = "N/A";
          if (prod?.ExtraParams?.AYB?.Mesa) {
            let contenedorData = contenedoresMap.get(prod.ExtraParams.AYB.Mesa);
            if (contenedorData) {
              aybContenedor = contenedorData.Nombre;
              let areaData = areasMap.get(contenedorData.Area);
              if (areaData) {
                aybArea = areaData.Nombre;
              }
            }
            let meseroData = meserosMap.get(prod.ExtraParams.AYB.Mesero);
            if (meseroData) {
              NombreMesero = meseroData.Nombre;
            }
          }
          try {
            Object.entries(prod.Pagos).forEach((pago) => {
              let noGrava = false;
              if (
                prod.Nombre.includes("Nueva Membresia") ||
                prod.Nombre.includes("Cuota Extraordinaria")
              ) {
                noGrava = true;
              }
              let iva = prod.Iva / 100 + 1;
              if (new moment(el.FechaCreacion).format("YYYY") == "2023") {
                if (prod.STip == "Cuenta") {
                  pago[1].def.C = pago[1].def.C + pago[1].dsc.C * -1;
                  pago[1].rel.C = pago[1].rel.C + pago[1].dsc.C * -1;
                  pago[1].dsc.C = 0;
                  prod.Descuentos = [];
                }
              }
              let imp = !noGrava
                ? parseFloat(pago[1].def.C - pago[1].def.C / iva).toFixed(2)
                : 0;
              let st = !noGrava
                ? parseFloat(pago[1].def.C - imp).toFixed(2)
                : parseFloat(pago[1].def.C).toFixed(2);



              let producto = {
                Fecha: el.FechaVenta,
                Cliente: el.Cliente.Nombre,
                Cajero: cajeroData.Nomb,
                Apodo: el.Cliente.Apodo ? " - " + el.Cliente.Apodo : "",
                Membresia: membresiaData
                  ? membresiaData?.Code?.Pre + "-" + membresiaData?.Code?.Pos
                  : "N/A",
                Folio: el.Folio,
                Departamento: el.Departamento,
                ClaveSAT: prod.Familia ? prod.Familia.C : "-",
                Familia: familia,
                Categoria: prod.Categoria ? prod.Categoria.N : "-",
                IdProducto: prod.Id,
                Producto: prod.Nombre,
                Cantidad: pago[0] ? Number(parseFloat(pago[1].cnt).toFixed(2)) : "",
                Monto: Number(pago[1].rel.C),
                Moneda: pago[1].rel.M,
                Mesa: aybContenedor,
                Mesero: NombreMesero,
                Personas: el.Comensales,
                Area: aybArea,
                TipoPago: pago[0] ? pago[1].name : "",
                Descuento: pago[1].dsc
                  ? Number(parseFloat(pago[1].dsc.C).toFixed(2))
                  : "-",
                Autorizacion: pago[0] ? pago[1].code : "",
                Subtotal: Number(st),
                Impuestos: Number(imp),
                Hora: new moment(el.FechaCreacion).format("HH:mm"),
                Turno: el.Turno,
                SegmentoTarifario: segmentoTarifario,
                MercadoTarifario: mercadoTarifario,
              };
              // Acumular totales inline
              totales.Cantidad += Number(producto.Cantidad) || 0;
              totales.Monto += Number(producto.Subtotal) + Number(producto.Impuestos);
              totales.Descuento += Number(producto.Descuento) || 0;
              totales.Subtotal += Number(producto.Subtotal);
              totales.Impuestos += Number(producto.Impuestos);
              productosVenta.push(producto);
            });
            if (Object.entries(prod.Pagos).length == 0) {
              let producto = {
                Fecha: el.FechaVenta,
                Cajero: cajeroData.Nomb,
                Cliente: el.Cliente.Nombre,
                Personas: el.Comensales,
                Apodo: el.Cliente.Apodo ? " - " + el.Cliente.Apodo : "",
                Membresia: membresiaData
                  ? membresiaData?.Code?.Pre + "-" + membresiaData?.Code?.Pos
                  : "N/A",
                Folio: el.Folio,
                Departamento: el.Departamento,
                ClaveSAT: prod.Familia ? prod.Familia.C : "-",
                Familia: familia,
                Categoria: prod.Categoria ? prod.Categoria.N : "-",
                IdProducto: prod.Id,
                Producto: prod.Nombre,
                Cantidad: prod.Cnt,
                Monto: 0,
                Moneda: "MXN",
                Mesa: aybContenedor,
                Mesero: NombreMesero,
                Area: aybArea,
                TipoPago: "SIN PAGO",
                Descuento: 0,
                Autorizacion: 0,
                Subtotal: 0,
                Impuestos: 0,
                Hora: new moment(el.FechaCreacion).format("HH:mm"),
                Turno: el.Turno,
                SegmentoTarifario: segmentoTarifario,
                MercadoTarifario: mercadoTarifario,
              };
              productosVenta.push(producto);
            }
          } catch (e) {
            console.log(el.Folio);
          }
        });
      });
      this.datos.processedData = productosVenta;
      this.datos.totales = totales;
      console.timeEnd("ProcessVentas");
    },
    async getMeserosAB() {
      const snapshot =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "AYB/Meseros"
        );
      if (snapshot.exists()) {
        this.meseros = [];
        this.meseros = this.$pgsHelper.ArrayObjectToArray(snapshot.val());
        this.meseros.forEach((mesero) => {
          if (mesero.Deptos) {
            let deptos = Object.entries(mesero.Deptos);
            let textDepto = "";
            deptos.forEach((depto) => {
              let testDepto = this.$pgsHelper.getById(
                this.departamentos,
                "Id",
                depto[0]
              );
              if (testDepto) {
                textDepto = textDepto + testDepto.Nombre + " ";
              }
            });
            mesero.DepartamentoText = textDepto;
          } else {
            mesero.DepartamentoText = "";
          }
        });
      }
    },
    cleanFilter() {
      this.input_date = new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10);
      this.input_date_final = new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10);
      this.input_folio = "";
      this.selectClient = "";
      this.selectDep = "ALL";
      this.currentPage = 1;
    },
    showDetail(res) {
      this.selectedRes = res;
      if (this.selectedRes) {
        let prod = Object.entries(this.selectedRes.Catalogo);
        this.selectedRes.ListProducts = prod;
        let pag = Object.entries(this.selectedRes.Pagos);
        this.selectedRes.ListPagos = pag;
      } else {
        this.selectedRes.ListProducts = [];
      }
      this.showModal = true;
    },
    selectDate(arg) {
      this.input_date = moment(arg);
      this.input_date_final = moment(arg);
    },
    formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    async getCajas() {
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "PDV/Cajas"
        );
      this.data_cajas = this.$pgsHelper.ArrayObjectToArray(data.val());
    },
    async getContenedores() {
      let mesas = [];
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "AYB/Contenedores"
        );
      if (data.exists()) {
        const dataContenedores = Object.entries(data.val());
        dataContenedores.forEach((mapa) => {
          const contenedores = this.$pgsHelper.ArrayObjectToArray(mapa[1]);
          contenedores.forEach((mesa) => {
            mesas.push(mesa);
          });
        });
      }
      this.contenedores = mesas;
    },
    async getAreas() {
      let areasList = [];
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "AYB/Areas"
        );
      if (data.exists()) {
        const dataAreas = Object.entries(data.val());
        dataAreas.forEach((mapa) => {
          const areas = this.$pgsHelper.ArrayObjectToArray(mapa[1]);
          areas.forEach((mesa) => {
            areasList.push(mesa);
          });
        });
      }
      this.areas = areasList;
    },
    async getCashiers() {
      const snapshot =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "PDV/Cajeros"
        );

      if (snapshot.exists()) {
        this.cashiers = [];
        Object.keys(snapshot.val()).forEach((id) => {
          const toAdd = snapshot.val()[id];
          if (toAdd) {
            toAdd.Id = id;
            // ajustar usuarios antiguos
            this.cashiers.push(toAdd);
          }
        });
      }
    },
    selectDateFinal(arg) {
      this.input_date_final = moment(arg);
    },
    async getVentas() {
      const startDate = this.input_date;
      const endDate = this.input_date_final;
      const end = endDate.replace(/.$/, (c) =>
        String.fromCharCode(c.charCodeAt(0) + 1)
      );
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      let filter = [
        firestore.where("FechaVenta", ">=", startDate),
        firestore.where("FechaVenta", "<", end),
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
      ];

      if (this.selectDep != "ALL") {
        filter.push(firestore.where("Departamento", "==", this.selectDep));
      }

      if (this.input_folio != "") {
        filter.push(firestore.where("Folio", "==", this.input_folio));
      }

      if (this.selectClient != "") {
        filter.push(firestore.where("Cliente.Id", "==", this.selectClient));
      }

      const data = await firestore.queryBuilder("PDV_Ventas", filter);
      let preData = [];
      preData = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });

      preData.forEach((item) => {
        item.fecha = new moment(item.FechaCreacion).format("YYYY-MM-DD HH:mm");
      });

      preData = this.$_.orderBy(preData, "fecha", "desc");

      this.datos.all = preData;
    },
    async getCategories() {
      this.Categories = await this.fetchCategories();
    },
    async getFamilias() {
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "PDV/Productos/Familias"
        );

      this.familias = [];
      this.familias = this.$pgsHelper.ArrayObjectToArray(data.val());
    },
    ...mapActions("Categorias", { fetchCategories: "getCategories" }),
    async searchVentas() {
      this.loadingData = true;
      this.datos = { processedData: [], all: [], totales: { Cantidad: 0, Descuento: 0, Monto: 0, Subtotal: 0, Impuestos: 0 } };
      this.currentPage = 1;
      try {
        await this.getVentas();
        await this.$nextTick();
        this.processVentas();
      } catch (e) {
        console.error("Error en búsqueda:", e);
      } finally {
        this.loadingData = false;
      }
    },
  },
  beforeCreate: function () { },
  beforeMount: function () {
    this.getAreas();
    this.getContenedores();
    this.getCategories();
    this.getFamilias();
    this.getCajas();
    this.getCashiers();
    this.getMeserosAB();
    this.$emit("useNav", true);
  },
};
</script>

<style>
.input input {
  border-bottom: 1px solid black;
  width: 100%;
}
</style>
